//services/AuthApi.js
import axios from "axios";

import config from "../config";
import { getToken } from "../utils/tokenUtils";

const apiurl = config.API_URL;

// Re-export getToken from tokenUtils for backward compatibility
export { getToken };

const getTepmToken = () => {
  return localStorage.getItem("temp_token");
};

export const register = async (data) => {
  console.log("Registering user with data", data);
  try {
    const response = await axios.post(`${apiurl}/api/v1/register`, data);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const otpVerify = async (data) => {
  try {
    const response = await axios.post(`${apiurl}/api/v1/verify-OTP`, data);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const login = async (data, redirect) => {
  console.log("data", data);
  console.log("redirect", redirect);
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/login?redirect=${redirect}`,
      data
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// export const login = async (data) => {
//   try {
//     const response = await axios.post(`${apiurl}/api/v1/login`, data);
//     return response.data;
//   } catch (error) {
//     return Promise.reject(error.response.data);
//   }
// };


export const switchAccount = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/api/v1/user/switch-account`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const resendOTP = async (data) => {
  try {
    const response = await axios.post(`${apiurl}/api/v1/resend-OTP`, data);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const wrongEmail = async (data) => {
  try {
    const response = await axios.post(`${apiurl}/api/v1/wrong-email`, data);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const forgotPassword = async (data) => {
  try {
    const response = await axios.post(`${apiurl}/api/v1/forgot-password`, data);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const verifyToken = async () => {
  const token = getToken();
  if (!token) {
    return Promise.reject({ token_valid: false, message: "No token found" });
  }
  
  try {
    const response = await axios.get(`${apiurl}/api/v1/verify-token`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const userLogout = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/api/v1/user/logout`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const changePasswordbyOld = async (data) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/change-password`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const changePasswordbyOTP = async () => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/profile/change-password-otp/send`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const verifyOtpNow = async (otp, session_id) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/profile/change-password-otp/verify/${session_id}`,
      { otp: otp },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const changePasswordbyOTPUpdate = async (data) => {
  const token = getToken();
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/profile/change-password-otp/update`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// social login   /auth/{provider}/callback
// export const socialLoginCallback = async (provider) => {
//   try {
//     const response = await axios.get(
//       `${apiurl}/api/v1/auth/${provider}/callback`
//     );
//     return response.data;
//   } catch (error) {
//     return Promise.reject(error.response.data);
//   }
// };

// reset password
export const resetPassword = async (token, data) => {
  console.log("data", data);
  console.log("token", token);
  console.log("url", `${apiurl}/api/v1/forgot-password/${token}`);
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/forgot-password/${token}`,
      data
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// https://api.autovertest.com/api/v1/user/login-data
export const loginData = async (deviceInfo) => {

  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/login-data`, deviceInfo,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


// API to change the type of User ( individual / organization ): 
export const changeAccountType = async (data) => {
  const token = getTepmToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/change-account-type`, data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};



// crate another account with same email 

export const createAnotherAccount = async (data) => {
  console.log("data", data);
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/create-another-account?create_account=${data.create_account}&encrypted_data=${data.encrypted_data}`
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
}
